document.querySelectorAll('.header__menu-item').forEach((item) => {
  const details = item.closest('details');

  if (details) {
    details.addEventListener('mouseenter', () => {
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      details.removeAttribute('open');
    });
  }
});

